import { NumericInput } from "@components/inputs/numericInput/NumericInput";
import React, { useCallback } from "react";

import { IValidationError } from "../../../model/Validator.types";
import { IValueInterval } from "../../smart/smartValueHelper";
import { IInputOnChangeEvent, IInputProps } from "../input";
import { StyledNumericRange } from "./NumericRange.styles";

export interface IValidationErrorInterval {
    from: IValidationError;
    to: IValidationError;
}

interface IProps extends Omit<IInputProps<IValueInterval<number>>, "error" | "onChange"> {
    error: IValidationErrorInterval;
    onChange: (value: IValueInterval<number>) => void;
}

export const NumericRange: React.FC<IProps> = (props) => {
    const { width, value, onChange, onBlur, error, ...forwardProps } = props;

    const handleChange = useCallback((key: keyof IValueInterval, e: IInputOnChangeEvent) => {
        const newVal = {
            ...value,
            [key]: e.value
        };
        onChange(newVal);
    }, [onChange, value]);

    const handleChangeFrom = useCallback((e: IInputOnChangeEvent) => handleChange("from", e), [handleChange]);
    const handleChangeTo = useCallback((e: IInputOnChangeEvent) => handleChange("to", e), [handleChange]);

    return (
        <>
            <StyledNumericRange _width={width}>
                <NumericInput {...forwardProps}
                              isSharpRight
                              value={value?.from}
                              error={error?.from}
                              onBlur={onBlur}
                              onChange={handleChangeFrom}
                />
                <span>&nbsp;-&nbsp;</span>
                <NumericInput {...forwardProps}
                              isSharpLeft
                              value={value?.to}
                              error={error?.to}
                              onBlur={onBlur}
                              onChange={handleChangeTo}
                />
            </StyledNumericRange>
        </>
    );
};